import { Customer } from '../../models/Booking/Customer'
import { Action } from '../Actions'
import { CustomerElement } from './CustomerElem'
import LS from '../../utils/LocalStorageManager'

const ACTION_ADD_CUSTOMER = 'ADD_CUSTOMER'
const ACTION_REMOVE_CUSTOMER = 'REMOVE_CUSTOMER'
const ACTION_UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
const ACTION_RESTORE_CUSTOMERS = 'ACTION_RESTORE_CUSTOMERS'

const initialState: CustomersState = {
    customers: [],
    activeCustomer: new Customer
}

export interface CustomersState {
    customers: CustomerElement[],
    activeCustomer: Customer
}

export class CustomersActions {
    static addCustomer = (id: number, customer: Customer): Action => ({ type: ACTION_ADD_CUSTOMER, payload: { id: id, customer: customer } })
    static removeCustomer = (id: number): Action => ({ type: ACTION_REMOVE_CUSTOMER, payload: { id: id } })
    static updateCustomer = (id: number, customer: Customer): Action => ({ type: ACTION_UPDATE_CUSTOMER, payload: { id: id, customer: customer } })
    static restoreCustomersFromLs = (): Action => ({ type: ACTION_RESTORE_CUSTOMERS, payload: {} })
}

export function reduce(state: CustomersState = initialState, action: Action) {
    switch (action.type) {
        case ACTION_ADD_CUSTOMER: {
            const { customers } = state
            if (!customers[action.payload.id]) {
                customers[action.payload.id] = action.payload.customer
            }
            LS.saveCustomers(customers);
            return {
                ...state,
                customers: customers
            }
        }
        case ACTION_REMOVE_CUSTOMER: {
            const { customers } = state
            if (customers[action.payload.id]) {
                customers.splice(customers.indexOf(action.payload.id), 1)
            }
            LS.saveCustomers(customers);
            return {
                ...state,
                customers: customers
            }
        }
        case ACTION_UPDATE_CUSTOMER: {
            state.customers[action.payload.id] = action.payload.customer;
            let resultState = {
                ...state,
                customers: [
                    ...state.customers
                ]
            };
            LS.saveCustomers(resultState.customers);
            return resultState;
        }
        case ACTION_RESTORE_CUSTOMERS: {
            const customers = LS.getCustomersData();
            
            return {
                ...state,
                ...(customers ? { customers : customers } : {})
            }
        }
        default:
            return state;
    }
}